export const MerkleWL12 = [
  "0x719f17ed85c9208f5fa7dbf4067bcffa6d63f508",
  "0xeac5f9b3cd48123a69fe69ce93a7f58100a56552",
  "0xb5de7db95d7ce30c5ecdeaf1aade046e998580fd",
  "0x06c1bae17aafe75f40dfb86667e586ef837a8ff4",
  "0x1C53cED8017428698A8a537c6fEE95F84FC7C024"
];